// source: no/jotta/openapi/comment/v2/comment.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_avatar_pb = require('../../../../../no/jotta/openapi/avatar_pb.js');
goog.object.extend(proto, no_jotta_openapi_avatar_pb);
var google_api_annotations_pb = require('../../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.AddCommentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.AddCommentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.AddReplyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.AddReplyResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.Comment', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.DeleteCommentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.DeleteCommentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.DeleteReplyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.DeleteReplyResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.Direction', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetCommentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetCommentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetCommentsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetCommentsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetGroupsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetRepliesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.GetRepliesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.Group', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.Item', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.UpdateCommentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.UpdateCommentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.UpdateReplyRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.comment.v2.UpdateReplyResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.Comment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.comment.v2.Comment.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.Comment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.Comment.displayName = 'proto.no.jotta.openapi.comment.v2.Comment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.Item = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.Item, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.Item.displayName = 'proto.no.jotta.openapi.comment.v2.Item';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.Group = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.Group, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.Group.displayName = 'proto.no.jotta.openapi.comment.v2.Group';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetCommentsRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.comment.v2.GetCommentsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetCommentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetCommentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.AddCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.AddCommentRequest.displayName = 'proto.no.jotta.openapi.comment.v2.AddCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.AddCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.AddCommentResponse.displayName = 'proto.no.jotta.openapi.comment.v2.AddCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.UpdateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.displayName = 'proto.no.jotta.openapi.comment.v2.UpdateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.UpdateCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.displayName = 'proto.no.jotta.openapi.comment.v2.UpdateCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.DeleteCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.displayName = 'proto.no.jotta.openapi.comment.v2.DeleteCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.DeleteCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.displayName = 'proto.no.jotta.openapi.comment.v2.DeleteCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetCommentRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetCommentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetCommentResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetRepliesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetRepliesRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetRepliesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.comment.v2.GetRepliesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetRepliesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetRepliesResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetRepliesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.AddReplyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.AddReplyRequest.displayName = 'proto.no.jotta.openapi.comment.v2.AddReplyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.AddReplyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.AddReplyResponse.displayName = 'proto.no.jotta.openapi.comment.v2.AddReplyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.UpdateReplyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.displayName = 'proto.no.jotta.openapi.comment.v2.UpdateReplyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.UpdateReplyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.displayName = 'proto.no.jotta.openapi.comment.v2.UpdateReplyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.DeleteReplyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.displayName = 'proto.no.jotta.openapi.comment.v2.DeleteReplyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.DeleteReplyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.displayName = 'proto.no.jotta.openapi.comment.v2.DeleteReplyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.comment.v2.GetGroupResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupsRequest.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.comment.v2.GetGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.comment.v2.GetGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.comment.v2.GetGroupsResponse.displayName = 'proto.no.jotta.openapi.comment.v2.GetGroupsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.comment.v2.Comment.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.Comment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.Comment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Comment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentId: (f = msg.getParentId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    parentIdDeprecated: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contextKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    text: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAtMillis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ownerUsername: jspb.Message.getFieldWithDefault(msg, 6, ""),
    ownerFullName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    ownerAvatar: (f = msg.getOwnerAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f),
    repliesList: jspb.Message.toObjectList(msg.getRepliesList(),
    proto.no.jotta.openapi.comment.v2.Comment.toObject, includeInstance),
    cursor: jspb.Message.getFieldWithDefault(msg, 9, ""),
    repliesCursor: (f = msg.getRepliesCursor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    repliesCursorDeprecated: jspb.Message.getFieldWithDefault(msg, 10, ""),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.Comment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.Comment;
  return proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.Comment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 102:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentIdDeprecated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMillis(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerUsername(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerFullName(value);
      break;
    case 12:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setOwnerAvatar(value);
      break;
    case 8:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.addReplies(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 110:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRepliesCursor(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepliesCursorDeprecated(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.Comment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getParentIdDeprecated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOwnerUsername();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOwnerFullName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOwnerAvatar();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getRepliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRepliesCursor();
  if (f != null) {
    writer.writeMessage(
      110,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRepliesCursorDeprecated();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue parent_id = 102;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getParentId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 102));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
*/
proto.no.jotta.openapi.comment.v2.Comment.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 102, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional string parent_id_deprecated = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getParentIdDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setParentIdDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string context_key = 3;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at_millis = 5;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getCreatedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setCreatedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string owner_username = 6;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getOwnerUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setOwnerUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string owner_full_name = 7;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getOwnerFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setOwnerFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional no.jotta.openapi.Avatar owner_avatar = 12;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getOwnerAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 12));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
*/
proto.no.jotta.openapi.comment.v2.Comment.prototype.setOwnerAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.clearOwnerAvatar = function() {
  return this.setOwnerAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.hasOwnerAvatar = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated Comment replies = 8;
 * @return {!Array<!proto.no.jotta.openapi.comment.v2.Comment>}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getRepliesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.comment.v2.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 8));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.comment.v2.Comment>} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
*/
proto.no.jotta.openapi.comment.v2.Comment.prototype.setRepliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.addReplies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.no.jotta.openapi.comment.v2.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.clearRepliesList = function() {
  return this.setRepliesList([]);
};


/**
 * optional string cursor = 9;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue replies_cursor = 110;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getRepliesCursor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 110));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
*/
proto.no.jotta.openapi.comment.v2.Comment.prototype.setRepliesCursor = function(value) {
  return jspb.Message.setWrapperField(this, 110, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.clearRepliesCursor = function() {
  return this.setRepliesCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.hasRepliesCursor = function() {
  return jspb.Message.getField(this, 110) != null;
};


/**
 * optional string replies_cursor_deprecated = 10;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getRepliesCursorDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setRepliesCursorDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string encoded_content_ref = 11;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Comment} returns this
 */
proto.no.jotta.openapi.comment.v2.Comment.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.Item.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Item.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalCommentCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.Item}
 */
proto.no.jotta.openapi.comment.v2.Item.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.Item;
  return proto.no.jotta.openapi.comment.v2.Item.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.Item}
 */
proto.no.jotta.openapi.comment.v2.Item.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.Item.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Item.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalCommentCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Item} returns this
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 total_comment_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.getTotalCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.Item} returns this
 */
proto.no.jotta.openapi.comment.v2.Item.prototype.setTotalCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.Group.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.Group} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Group.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalCommentCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.Group}
 */
proto.no.jotta.openapi.comment.v2.Group.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.Group;
  return proto.no.jotta.openapi.comment.v2.Group.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.Group} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.Group}
 */
proto.no.jotta.openapi.comment.v2.Group.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.Group.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.Group} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.Group.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalCommentCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.Group} returns this
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 total_comment_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.getTotalCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.Group} returns this
 */
proto.no.jotta.openapi.comment.v2.Group.prototype.setTotalCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    direction: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sort: jspb.Message.getFieldWithDefault(msg, 4, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sortReplies: jspb.Message.getFieldWithDefault(msg, 6, 0),
    limitReplies: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetCommentsRequest;
  return proto.no.jotta.openapi.comment.v2.GetCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 4:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 6:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setSortReplies(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimitReplies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSort();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSortReplies();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getLimitReplies();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Direction direction = 3;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getDirection = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Direction sort = 4;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getSort = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setSort = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 limit = 5;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional Direction sort_replies = 6;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getSortReplies = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setSortReplies = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 limit_replies = 7;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.getLimitReplies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsRequest.prototype.setLimitReplies = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetCommentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.no.jotta.openapi.comment.v2.Comment.toObject, includeInstance),
    cursor: (f = msg.getCursor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    cursorDeprecated: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totalCommentCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetCommentsResponse;
  return proto.no.jotta.openapi.comment.v2.GetCommentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    case 102:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCursor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursorDeprecated(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetCommentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCursorDeprecated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalCommentCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.no.jotta.openapi.comment.v2.Comment>}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.comment.v2.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.comment.v2.Comment>} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.comment.v2.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};


/**
 * optional google.protobuf.StringValue cursor = 102;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.getCursor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 102));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.setCursor = function(value) {
  return jspb.Message.setWrapperField(this, 102, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.clearCursor = function() {
  return this.setCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional string cursor_deprecated = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.getCursorDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.setCursorDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_comment_count = 3;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.getTotalCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentsResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentsResponse.prototype.setTotalCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.AddCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.AddCommentRequest;
  return proto.no.jotta.openapi.comment.v2.AddCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.AddCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.AddCommentRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.AddCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.comment.v2.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.AddCommentResponse;
  return proto.no.jotta.openapi.comment.v2.AddCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.AddCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.AddCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.comment.v2.Comment} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {?proto.no.jotta.openapi.comment.v2.Comment|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.AddCommentResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.AddCommentResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.UpdateCommentRequest;
  return proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.comment.v2.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.UpdateCommentResponse;
  return proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.comment.v2.Comment} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {?proto.no.jotta.openapi.comment.v2.Comment|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateCommentResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.UpdateCommentResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.DeleteCommentRequest;
  return proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string comment_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.DeleteCommentResponse;
  return proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    commentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sort: jspb.Message.getFieldWithDefault(msg, 3, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetCommentRequest;
  return proto.no.jotta.openapi.comment.v2.GetCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSort();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string comment_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Direction sort = 3;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.getSort = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.setSort = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetCommentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.comment.v2.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetCommentResponse;
  return proto.no.jotta.openapi.comment.v2.GetCommentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentResponse}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.comment.v2.Comment} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {?proto.no.jotta.openapi.comment.v2.Comment|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.GetCommentResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.GetCommentResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetRepliesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    commentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    direction: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sort: jspb.Message.getFieldWithDefault(msg, 5, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetRepliesRequest;
  return proto.no.jotta.openapi.comment.v2.GetRepliesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 4:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetRepliesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSort();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string comment_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cursor = 3;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Direction direction = 4;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getDirection = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Direction sort = 5;
 * @return {!proto.no.jotta.openapi.comment.v2.Direction}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getSort = function() {
  return /** @type {!proto.no.jotta.openapi.comment.v2.Direction} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Direction} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setSort = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int32 limit = 6;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetRepliesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    repliesList: jspb.Message.toObjectList(msg.getRepliesList(),
    proto.no.jotta.openapi.comment.v2.Comment.toObject, includeInstance),
    cursor: (f = msg.getCursor()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    cursorDeprecated: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetRepliesResponse;
  return proto.no.jotta.openapi.comment.v2.GetRepliesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.addReplies(value);
      break;
    case 102:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCursor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursorDeprecated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetRepliesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRepliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCursorDeprecated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Comment replies = 1;
 * @return {!Array<!proto.no.jotta.openapi.comment.v2.Comment>}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.getRepliesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.comment.v2.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.comment.v2.Comment>} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.setRepliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.addReplies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.comment.v2.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.clearRepliesList = function() {
  return this.setRepliesList([]);
};


/**
 * optional google.protobuf.StringValue cursor = 102;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.getCursor = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 102));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.setCursor = function(value) {
  return jspb.Message.setWrapperField(this, 102, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.clearCursor = function() {
  return this.setCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional string cursor_deprecated = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.getCursorDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetRepliesResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetRepliesResponse.prototype.setCursorDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.AddReplyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    commentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    text: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.AddReplyRequest;
  return proto.no.jotta.openapi.comment.v2.AddReplyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.AddReplyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string comment_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.getCommentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.setCommentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string text = 3;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.AddReplyRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.AddReplyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.comment.v2.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.AddReplyResponse;
  return proto.no.jotta.openapi.comment.v2.AddReplyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.AddReplyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.AddReplyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.comment.v2.Comment} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {?proto.no.jotta.openapi.comment.v2.Comment|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.AddReplyResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.AddReplyResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    replyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.UpdateReplyRequest;
  return proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReplyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string reply_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.getReplyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.setReplyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.comment.v2.Comment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.UpdateReplyResponse;
  return proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Comment;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Comment.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional Comment comment = 1;
 * @return {?proto.no.jotta.openapi.comment.v2.Comment}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.comment.v2.Comment} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.comment.v2.Comment, 1));
};


/**
 * @param {?proto.no.jotta.openapi.comment.v2.Comment|undefined} value
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.setComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.comment.v2.UpdateReplyResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.comment.v2.UpdateReplyResponse.prototype.hasComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    replyId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.DeleteReplyRequest;
  return proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReplyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reply_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.prototype.getReplyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteReplyRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyRequest.prototype.setReplyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.DeleteReplyResponse;
  return proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.DeleteReplyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.DeleteReplyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupRequest;
  return proto.no.jotta.openapi.comment.v2.GetGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.no.jotta.openapi.comment.v2.Item.toObject, includeInstance),
    totalCommentCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupResponse;
  return proto.no.jotta.openapi.comment.v2.GetGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Item;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Item.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Item.serializeBinaryToWriter
    );
  }
  f = message.getTotalCommentCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated Item items = 1;
 * @return {!Array<!proto.no.jotta.openapi.comment.v2.Item>}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.comment.v2.Item>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.comment.v2.Item, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.comment.v2.Item>} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.comment.v2.Item}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.comment.v2.Item, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total_comment_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.getTotalCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupResponse.prototype.setTotalCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest;
  return proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string context_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.prototype.getContextKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountRequest.prototype.setContextKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalCommentCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse;
  return proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalCommentCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 total_comment_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.prototype.getTotalCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupCommentCountResponse.prototype.setTotalCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contextKeysCsv: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupsRequest;
  return proto.no.jotta.openapi.comment.v2.GetGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContextKeysCsv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContextKeysCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string context_keys_csv = 1;
 * @return {string}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.prototype.getContextKeysCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsRequest} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupsRequest.prototype.setContextKeysCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.comment.v2.GetGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.no.jotta.openapi.comment.v2.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.comment.v2.GetGroupsResponse;
  return proto.no.jotta.openapi.comment.v2.GetGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.comment.v2.Group;
      reader.readMessage(value,proto.no.jotta.openapi.comment.v2.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.comment.v2.GetGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.comment.v2.Group.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Group groups = 1;
 * @return {!Array<!proto.no.jotta.openapi.comment.v2.Group>}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.comment.v2.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.comment.v2.Group, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.comment.v2.Group>} value
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse} returns this
*/
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.comment.v2.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.comment.v2.Group}
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.comment.v2.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.comment.v2.GetGroupsResponse} returns this
 */
proto.no.jotta.openapi.comment.v2.GetGroupsResponse.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.comment.v2.Direction = {
  DESCENDING: 0,
  ASCENDING: 1
};

goog.object.extend(exports, proto.no.jotta.openapi.comment.v2);
